// Клиент для `/api/public/states` — main_app state'ы привязанного юзера.
// Типы — единый источник правды: ts-rs-генерация из
// `crates/backend/web_api_types/src/state.rs` (alias @webtypes, см.
// vite.config.ts / tsconfig.app.json). Регенерация — `cargo test -p web_api_types`.

import type { PublicStateMeta } from '@webtypes/PublicStateMeta'
import type { ExtractResult } from '@webtypes/ExtractResult'

export type { PublicStateMeta, ExtractResult }

const BASE = '/api/public/states'

async function ensureOk(resp: Response): Promise<void> {
  if (!resp.ok) {
    const text = await resp.text().catch(() => '')
    throw new Error(`${resp.status} ${resp.statusText}${text ? ': ' + text : ''}`)
  }
}

/// Список state'ов привязанного main_app аккаунта. Если линка нет — пустой массив.
export async function listStates(): Promise<PublicStateMeta[]> {
  const resp = await fetch(BASE, { credentials: 'same-origin' })
  await ensureOk(resp)
  return resp.json()
}

/// Извлечь компоновку (drillstring) из state'а. Telemetry не материализуется
/// заново — она уже в public.telemetry на момент push'а main_app'ом.
export async function extractState(stateId: number): Promise<ExtractResult> {
  const resp = await fetch(`${BASE}/${stateId}/extract`, {
    method: 'POST',
    credentials: 'same-origin',
  })
  await ensureOk(resp)
  return resp.json()
}
